import { OfflinePaymentTypeGroupActionTypes, OfflinePaymentTypeGroupState } from "./types";
import { fetchError, fetchRequest, fetchSuccess } from "./actions";
import { createReducer } from "typesafe-actions";

export const initialState: OfflinePaymentTypeGroupState = {
  loading: false,
  errors: undefined,
  data: []
};

type ActionType =
  | ReturnType<typeof fetchRequest>
  | ReturnType<typeof fetchSuccess>
  | ReturnType<typeof fetchError>;

export default createReducer<OfflinePaymentTypeGroupState, ActionType>(initialState)
  .handleType(OfflinePaymentTypeGroupActionTypes.FETCH, state => ({
    ...state,
    loading: true,
    data: [],
    errors: undefined
  }))
  .handleType(OfflinePaymentTypeGroupActionTypes.FETCH_SUCCESS, (state, action) => ({
    ...state,
    loading: false,
    data: (action.payload.data ? action.payload.data : []),
    errors: undefined
  }))
  .handleType(OfflinePaymentTypeGroupActionTypes.FETCH_ERROR, (state, action) => ({
    ...state,
    loading: false,
    data: [],
    errors: action.payload
  }));
